// Page metadata shared by the client router and the build-time prerender.
export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://promptguessr.ru').replace(/\/+$/, '')
export const SITE_NAME = 'Промптгесс'
const DEFAULT_DESCRIPTION = 'Игра в картинки и слова с ИИ: один придумывает сцену, ИИ её рисует, остальные описывают картинку, не называя главного.'
const DEFAULT_IMAGE = '/og/default.jpg'

export function headFor(route) {
  const meta = route.meta || {}
  const path = route.path === '/' ? '/' : route.path.replace(/\/+$/, '')
  const title = meta.title ? (meta.fullTitle ? meta.title : `${meta.title} — ${SITE_NAME}`) : SITE_NAME
  const description = meta.description || DEFAULT_DESCRIPTION
  const url = meta.canonical === false ? null : `${SITE_URL}${path}`
  const home = `${SITE_URL}/`
  let structuredData = []
  if (path === '/') {
    structuredData = [
      { '@context': 'https://schema.org', '@type': 'WebSite', name: SITE_NAME, url: home, inLanguage: 'ru' },
      { '@context': 'https://schema.org', '@type': 'Organization', name: SITE_NAME, url: home, email: 'info@simulweb.ru' },
    ]
  } else if (url) {
    structuredData = [
      { '@context': 'https://schema.org', '@type': 'WebPage', name: title, description, url, inLanguage: 'ru', isPartOf: { '@type': 'WebSite', name: SITE_NAME, url: home } },
      { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: [
        { '@type': 'ListItem', position: 1, name: SITE_NAME, item: home },
        { '@type': 'ListItem', position: 2, name: meta.title, item: url },
      ] },
    ]
  }
  return {
    title,
    description,
    url,
    image: `${SITE_URL}${meta.image || DEFAULT_IMAGE}`,
    robots: meta.robots || (meta.prerender ? 'index, follow' : 'noindex, follow'),
    preloadImage: meta.preloadImage || null,
    structuredData,
  }
}

const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char])

export function renderHead(head) {
  const json = data => JSON.stringify(data).replace(/</g, '\\u003c')
  return [
    `<title>${escapeHtml(head.title)}</title>`,
    `<meta name="description" content="${escapeHtml(head.description)}" />`,
    `<meta name="robots" content="${head.robots}" />`,
    ...(head.url ? [`<link rel="canonical" href="${escapeHtml(head.url)}" />`] : []),
    '<meta property="og:type" content="website" />',
    `<meta property="og:site_name" content="${SITE_NAME}" />`,
    '<meta property="og:locale" content="ru_RU" />',
    `<meta property="og:title" content="${escapeHtml(head.title)}" />`,
    `<meta property="og:description" content="${escapeHtml(head.description)}" />`,
    ...(head.url ? [`<meta property="og:url" content="${escapeHtml(head.url)}" />`] : []),
    `<meta property="og:image" content="${escapeHtml(head.image)}" />`,
    '<meta property="og:image:width" content="1200" />',
    '<meta property="og:image:height" content="630" />',
    '<meta name="twitter:card" content="summary_large_image" />',
    // The largest image of the first screen (LCP) starts loading together with the HTML.
    ...(head.preloadImage ? [`<link rel="preload" as="image" href="${escapeHtml(head.preloadImage)}" fetchpriority="high" />`] : []),
    ...head.structuredData.map(data => `<script type="application/ld+json">${json(data)}</script>`),
  ].join('\n    ')
}

// Keeps the document head in sync during client-side navigation.
export function applyHead(head) {
  document.title = head.title
  const set = (selector, attribute, value) => document.head.querySelector(selector)?.setAttribute(attribute, value)
  set('meta[name="description"]', 'content', head.description)
  set('meta[name="robots"]', 'content', head.robots)
  if (head.url) set('link[rel="canonical"]', 'href', head.url)
  set('meta[property="og:title"]', 'content', head.title)
  set('meta[property="og:description"]', 'content', head.description)
  if (head.url) set('meta[property="og:url"]', 'content', head.url)
  set('meta[property="og:image"]', 'content', head.image)
}
